import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import { useSelector} from "react-redux";
import {
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Cell,
    ResponsiveContainer,
    ZAxis,
    LineChart, ReferenceLine, LabelList, ComposedChart, Text
} from 'recharts';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const colors = scaleOrdinal(schemeCategory10).range();


const useStyles = makeStyles(theme => ({


    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',

        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch',
    },
    mainChart: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch'
        //backgroundColor: 'cyan'
    }

}));




const SlaBubblesChart = (props) => {
    const classes = useStyles();

    const [left, setLeft] = useState("dataMin");
        const [right, setRight] = useState("dataMax");
        const [refAreaLeft, setRefAreaLeft] = useState("");
        const [refAreaRight, setRefAreaRight]= useState("");
        const [top, seTop] = useState("dataMax+1");
        const [bottom, setBottom] = useState("dataMin-1");
        const [top2, setTop2] = useState("dataMax+20");
        const [bottom2, setBottom2] = useState("dataMin-20");
        const [animation, setAnimation] = useState(true);






    if (props.series.length === 0) {
        return (<Typography>gerando informações...</Typography>)
    }
 //   console.log("series", props.series);
    const range = [200, 1000];
    const CustomTooltip = ({ active, payload, label }) => {
      //  console.log("customtooltip", active, payload, label);
        if (active && payload && payload.length ) {
            return (
                <div className="custom-tooltip">
                    {/*<p className="label">{`OS: ${payload[0].payload.os.ordemServicoId}`}</p>*/}
                    {/*<p className="label">{`Chegada: ${payload[0].payload.os.DTChegada}`}</p>*/}
                    {/*<p className="label">{`Etapa atual: ${payload[0].payload.os.peDescricao}`}</p>*/}
                    {/*<p className="label">{`${payload[0].payload.os.Horas}horas de ${payload[0].payload.os.tempoHr}  (${Math.round(payload[0].payload.os.percentualDoSLA)}%)`}</p>*/}

                </div>
            );
        }

        return null;
    };

    let renderLabel = function(entry) {
        return entry.z;
    }




    return (
      <React.Fragment>

          <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>



              {
                      props.series.map((seriePrioridade, index) => {
                   //       console.log("scatter.series.map", index, entry);
                          const hh = props.headers.find(h => h.priId === seriePrioridade[0].priId);

                          const refValue = hh.tempoHr;

                          return (

                              <ResponsiveContainer width="100%" height={160} key={index}>
                              <ComposedChart
                                            width="100%"
                                          height={160}
                                          margin={{
                                              top: 10,
                                              right: 100,
                                              bottom: 0,
                                              left: 0,
                                          }}
                                      >
                              <XAxis
                                  type="number"
                                  dataKey="x"
                                  unit="h"
                                  height={80}
                                  interval={0}
                                  tick={{ fontSize: 48 }}
                                  tickLine={{ transform: 'translate(0, -6)' }}
                              />
                              <YAxis
                                  type="number"
                                  dataKey="y"
                                  domain={[0, 'dataMax + 2']}
                                  tick={false}
                                  tickLine={false}
                                  axisLine={false}

                              />
                                  <ReferenceLine y={2} stroke="" label={props.headers[index].priDescricao } />
                                  <ReferenceLine x={refValue} stroke="red" label="PRAZO" strokeWidth={2} />
                                  <ZAxis type="number" dataKey="z" range={range} scale="linear" />
                                  <Tooltip  content={<CustomTooltip />}  />


                                  <Scatter data={seriePrioridade}    >

                                      {seriePrioridade.map((entry, index) => {
                                          const fillColor = (entry.x>refValue)? 'red' : "#3B9CEAFF";

                                              return (<React.Fragment>
                                                  <LabelList dataKey="z" position="top"/>
                                                  <Cell key={`cell-${index}`} fill={fillColor}/>
                                              </React.Fragment>)

                                      })}
                                  </Scatter>

                          </ComposedChart>
                          </ResponsiveContainer>

                          );
                      })
                  }

              </Grid>
          </Grid>

      </React.Fragment>
    );

}

export default (SlaBubblesChart)
